var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"b-background",attrs:{"app":"","flat":"","color":"white"}},[_c('v-toolbar-title',{staticClass:"ml-12"}),_c('v-spacer'),_c('router-link',{staticClass:"b-signin-link",attrs:{"to":"/user-stores"}},[_vm._v("Switch Account")]),_c('span',{staticClass:"b-signin-link",on:{"click":_vm.logout}},[_vm._v("Logout")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }